import { render, staticRenderFns } from "./TenderInfo.vue?vue&type=template&id=f97b1f48&"
import script from "./TenderInfo.vue?vue&type=script&lang=js&"
export * from "./TenderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports